import { S, G, M } from './types'
import { Getters, Mutations } from 'vuex'
import { v4 as uuidV4 } from 'uuid'

/* -------------------------------------------------------------------------- */

const state = (): S => ({
  text: null,
  token: null
})

/* -------------------------------------------------------------------------- */

const getters: Getters<S, G> = {
  text: state => state.text,
  token: state => state.token
}

/* -------------------------------------------------------------------------- */

const mutations: Mutations<S, M> = {
  set: (state, { text }) => {
    state.text = text || null
    state.token = uuidV4()
  },

  clear: state => {
    state.text = null
    state.token = null
  }
}

/* -------------------------------------------------------------------------- */

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
